import React, { Component } from 'react'
import { Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import './Sidebar.css';

import { Event } from '../support';
import GuardianRoute from '../shared/GuardianRoute';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import DevelopersSidebar from './sidebar/DevelopersSidebar';
import NavBarHeader from './components/navbar-header/NavBarHeader';
import SessionOverrideHighlighter from '../shared/session/SessionOverrideHighlighter';
import {
  TimbradoComprobantes,
  TimbradoComprobantesInfo,
  TimbradoRetenciones,
  TimbradoRetencionesInfo,
  AppLogs,
  AppLogsInfo,
  SystemLogs,
  SystemLogsInfo
} from '../developers';
import AccountSuspendedHighlighter from '../admin/clientes/list/components/AccountSuspendedHighlighter';
import EmisoresSoonToExpireHighlighter from '../app/emisores/EmisoresSoonToExpireHighlighter';


class DevelopersLayout extends Component {

  notification = null;

  state = {
    open: false,
  }

  _mounted = false;

  constructor(props) {
    super(props);

    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  componentWillUnmount() {
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  handleDrawerNeedsClose = () => {
    this.setState({
      open: false
    });
  }

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.open;

    this.setState({
      open: state
    });
  }

  render() {
    const { open } = this.state;

    const sidebarClassName = !!open ? 'sidebar-open' : '';

    return (
      <Container fluid className={ `app-wrapper ${sidebarClassName}` }>
        <NavBarHeader
          fluid={ false }
          onToggleSidebar={ this.handleOnToggleSidebar }
        />

        <HttpErrorMonitor />

        <AccountSuspendedHighlighter />

        <EmisoresSoonToExpireHighlighter />

        <SessionOverrideHighlighter />

        <div className="sidebar-backdrop" onClick={ this.handleOnToggleSidebar.bind(this, false) }></div>

        <div className="d-block d-lg-none d-xl-none">
          <DevelopersSidebar
            open={ open }
            onMenuItemClick={ this.handleOnToggleSidebar.bind(this, false) }
          />
        </div>

        <div className="app-container container">

          <div className="d-none d-lg-flex d-xl-flex">
            <DevelopersSidebar
              onMenuItemClick={ this.handleOnToggleSidebar.bind(this, false) }
            />
          </div>

          <div className="main-container">
            <div className="page-container">
              <GuardianRoute path="/developers/timbrado/comprobantes"
                component={ TimbradoComprobantes }
                can="developer.request.facturas"
                exact
              />
              <Route path="/developers/timbrado/comprobantes/:id" component={ TimbradoComprobantesInfo } exact />
              <GuardianRoute path="/developers/timbrado/retenciones"
                component={ TimbradoRetenciones }
                can="developer.request.retenciones"
                exact
              />
              <Route path="/developers/timbrado/retenciones/:id" component={ TimbradoRetencionesInfo } exact />
              <GuardianRoute path="/developers/audits/app-logs"
                component={ AppLogs }
                can="developer.logs.app"
                exact
              />
              <Route path="/developers/audits/app-logs/:id" component={ AppLogsInfo } exact />
              <GuardianRoute path="/developers/audits/system-logs"
                component={ SystemLogs }
                can="developer.logs.system"
                exact
              />
              <Route path="/developers/audits/system-logs/:id" component={ SystemLogsInfo } exact />
            </div>
          </div>
        </div>
      </Container>
    )
  }

}

export default DevelopersLayout;